import { ChatCard as Card } from '@/components/ChatCard';
import type { ChatCardFragment } from '@/utils/dato/generated';

const ChatCard = ({ description, title }: ChatCardFragment) => (
  <Card
    {...{
      description: description || undefined,
      title,
    }}
  />
);

export default ChatCard;
